var _circle, _circle2, _circle3, _circle4, _circle5, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDsHeader(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 306,
    height: 325,
    viewBox: "0 0 306 325",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 96.366,
    cy: 93.8123,
    r: 93.8123,
    fill: "#FFC2C7",
    fillOpacity: 0.8
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 96.366,
    cy: 93.8123,
    r: 93.8123,
    fill: "#FFC2C7",
    fillOpacity: 0.8
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 211.635,
    cy: 144.869,
    r: 93.8123,
    fill: "white",
    fillOpacity: 0.6
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 211.635,
    cy: 144.869,
    r: 93.8123,
    fill: "white",
    fillOpacity: 0.6
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 108.895,
    cy: 228.188,
    r: 93.8123,
    fill: "#7BD6E7",
    fillOpacity: 0.6
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M167.523 154.477C156.546 167.242 142.193 177.02 125.85 182.427C120.689 170.803 117.822 157.935 117.822 144.397C117.822 141.012 118.001 137.668 118.351 134.375C136.855 136.228 153.774 143.457 167.523 154.477Z",
    fill: "#E6416A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M122.68 185.047C113.594 188.018 103.891 189.625 93.8123 189.625C72.119 189.625 52.1641 182.182 36.3615 169.711C53.3662 150.492 78.2157 138.375 105.895 138.375C109.112 138.375 112.29 138.539 115.422 138.858C115.143 141.805 115 144.792 115 147.812C115 161.042 117.739 173.633 122.68 185.047ZM123.084 185.967C113.873 188.99 104.034 190.625 93.8123 190.625C71.8668 190.625 51.6813 183.089 35.702 170.465C21.6094 186.741 13.083 207.969 13.083 231.188C13.083 282.447 54.6365 324 105.895 324C153.83 324 193.277 287.662 198.192 241.03C164.57 237.242 136.329 215.682 123.084 185.967ZM34.9201 169.84C13.6219 152.643 0 126.318 0 96.8123C0 45.0012 42.0012 3 93.8123 3C132.037 3 164.922 25.8614 179.54 58.657C188.751 55.6347 198.591 54 208.812 54C260.623 54 302.625 96.0012 302.625 147.812C302.625 199.623 260.623 241.625 208.812 241.625C205.562 241.625 202.351 241.459 199.186 241.137C194.218 288.271 154.346 325 105.895 325C54.0842 325 12.083 282.999 12.083 231.188C12.083 207.732 20.6909 186.288 34.9201 169.84ZM35.5789 169.087C14.49 152.073 1 126.018 1 96.8123C1 45.5535 42.5535 4 93.8123 4C131.595 4 164.105 26.5767 178.587 58.9755C144.619 70.529 119.405 101.017 115.521 137.863C112.357 137.541 109.145 137.375 105.895 137.375C77.8993 137.375 52.7676 149.639 35.5789 169.087ZM178.992 59.8944C145.344 71.3035 120.361 101.486 116.516 137.97C134.334 139.978 150.641 146.977 164.005 157.535C178.098 141.259 186.625 120.032 186.625 96.8123C186.625 83.6925 183.902 71.2085 178.992 59.8944ZM164.129 158.913C185.218 175.927 198.708 201.982 198.708 231.188C198.708 234.172 198.567 237.123 198.291 240.035C165.068 236.286 137.156 214.997 124.037 185.649C139.661 180.335 153.433 171.015 164.129 158.913ZM163.346 158.289C152.75 170.265 139.108 179.483 123.633 184.73C118.722 173.416 116 160.932 116 147.812C116 144.828 116.141 141.877 116.416 138.965C134.021 140.952 150.135 147.863 163.346 158.289ZM164.787 158.16C179.017 141.712 187.625 120.268 187.625 96.8123C187.625 83.5823 184.886 70.9919 179.945 59.5772C189.031 56.6064 198.734 55 208.812 55C260.071 55 301.625 96.5535 301.625 147.812C301.625 199.071 260.071 240.625 208.812 240.625C205.596 240.625 202.418 240.461 199.286 240.142C199.565 237.195 199.708 234.208 199.708 231.188C199.708 201.682 186.086 175.357 164.787 158.16Z",
    fill: "#016479"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDsHeader);
export default __webpack_public_path__ + "static/media/ds-header.28ce776ca32e2728bd06329137e13c7c.svg";
export { ForwardRef as ReactComponent };